module.exports = __webpack_public_path__ + "assets/c2fb1dc43c45acffd2f2871b8e37f37a.png";